import React from 'react'
// import styles from './RequestTemplate.module.css'
import { useEffect } from 'react';

const RequestTemplate = () => {
  useEffect(()=> window.scrollTo(0, 0))
  return (
    <div>RequestTemplate</div>
  )
}

export default RequestTemplate